<section class="spriced-lite">
  <section class="intake-panel">
    <div class="translation-intake-row">
      <div class="field-control">
        <span>Files</span>
        <!-- Hidden native input — triggered by buttons -->
        <input #fileInput type="file" [attr.accept]="acceptedFileTypes" multiple (change)="onFileSelected($event)" style="display:none" />

        <div class="file-upload-area">
          <!-- No files: browse button -->
          <button *ngIf="!selectedFiles().length" type="button" class="browse-btn" (click)="fileInput.click()">
            <mat-icon>upload_file</mat-icon>
            Browse files
          </button>

          <!-- Files loaded: chips + add more -->
          <div *ngIf="selectedFiles().length" class="file-chips-row">
            <div class="file-chip" *ngFor="let f of selectedFiles(); let i = index">
              <mat-icon class="chip-file-icon">description</mat-icon>
              <span class="chip-name">{{ f.name }}</span>
              <button type="button" class="chip-remove" (click)="removeFile(i)" [matTooltip]="'Remove ' + f.name">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <button type="button" class="add-more-btn" (click)="fileInput.click()" matTooltip="Add more files">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="translation-columns-card">
        <span>Columns</span>
        <strong>{{ activeDeamSheet()?.columns?.length || 0 }}</strong>
      </div>

      <button
        type="button"
        class="primary-action translation-toolbar-action"
        (click)="previewTranslationConfiguration()"
        [disabled]="!deamAnalysis() || loading() || applyingPreview()"
      >
        <span class="rb-spinner" *ngIf="loading() || applyingPreview()" aria-hidden="true"></span>
        <mat-icon *ngIf="!loading() && !applyingPreview()">preview</mat-icon>
        {{ loading() ? 'Analyzing…' : (applyingPreview() ? 'Applying…' : 'Analyze & Preview') }}
      </button>

      <button
        type="button"
        class="primary-action translation-toolbar-action"
        (click)="persistDeamSchema()"
        [disabled]="persisting()"
        matTooltip="Save the final data into the database"
      >
        <mat-icon>save</mat-icon>
        {{ persisting() ? 'Saving...' : 'Save' }}
      </button>
    </div>

    <label class="field-control translation-join-key" *ngIf="selectedFiles().length >= 2">
        Join key
        <input
          type="text"
          placeholder="Column name used to join files"
          [ngModel]="primaryKey()"
          (ngModelChange)="updatePrimaryKey($event)"
          [disabled]="loading()"
        />
    </label>

    <!-- Analyze runs on open (autoAnalyze) and the panel has nothing to show
         until it lands — without this the modal reads as blank/broken. -->
    <div class="translation-analyzing" *ngIf="loading()">
      <span class="rb-spinner" aria-hidden="true"></span>
      <span>Analyzing {{ selectedFiles().length || '' }} file{{ selectedFiles().length === 1 ? '' : 's' }} — reading columns and building the preview…</span>
    </div>

    <div class="message-row">
      <p class="message error-message" *ngIf="error()">{{ error() }}</p>
    </div>

  </section>

  <section class="builder-card" *ngIf="false">
    <!-- <div class="card-heading">
      <div>
        <span class="eyebrow">Workflow Preview</span>
        <h3>{{ preview.workflowName || 'Generated workflow' }}</h3>
        <p>{{ workflowPreviewSummary() }}</p>
      </div>
      <div class="action-row">
        <button type="button" class="secondary-action" (click)="applyFilePlanJsonDraft()">Apply File Plan JSON</button>
        <button type="button" class="secondary-action" (click)="downloadDeamSchema()">Download DEAM JSON</button>
      </div>
    </div>

    <div class="validation-panel" *ngIf="preview.validationMessages?.length">
      <div class="message warning-message">
        <strong>Preview notes</strong>
        <ul>
          <li *ngFor="let note of preview.validationMessages">{{ note }}</li>
        </ul>
      </div>
    </div>

    <div class="plan-summary" *ngIf="filePlanCheck() as planCheck">
      <div class="plan-summary-card">
        <span>Files</span>
        <strong>{{ planCheck.totalCount }}</strong>
      </div>
      <div class="plan-summary-card">
        <span>Joined</span>
        <strong>{{ planCheck.joinedCount }}</strong>
      </div>
      <div class="plan-summary-card">
        <span>Individual</span>
        <strong>{{ planCheck.individualCount }}</strong>
      </div>
      <div class="plan-summary-card" [class.has-errors]="planCheck.errors.length">
        <span>Plan validation</span>
        <strong>{{ planCheck.errors.length }} errors</strong>
      </div>
    </div>

    <div class="validation-panel" *ngIf="filePlanCheck().errors.length || filePlanCheck().warnings.length">
      <div class="message error-message" *ngIf="filePlanCheck().errors.length">
        <strong>File plan errors</strong>
        <ul>
          <li *ngFor="let issue of filePlanCheck().errors">{{ issue }}</li>
        </ul>
      </div>
      <div class="message warning-message" *ngIf="filePlanCheck().warnings.length">
        <strong>File plan warnings</strong>
        <ul>
          <li *ngFor="let issue of filePlanCheck().warnings">{{ issue }}</li>
        </ul>
      </div>
    </div> -->

    <!-- preview-grid (Workflow JSON / DEAM Definition JSON / File Plan JSON) hidden -->

    <!-- <div class="validation-panel" *ngIf="preview.files?.length">
      <div class="message">
        <strong>Uploaded files in preview</strong>
        <div class="preview-file-grid">
          <article class="preview-file-card" *ngFor="let file of preview.files">
            <div class="preview-file-header">
              <div>
                <strong>{{ file.fileName || 'Unnamed file' }}</strong>
                <small>{{ file.entityName || 'No entity name' }}</small>
              </div>
              <span class="state-pill" [class.disabled]="file.mode === 'individual'">
                {{ file.mode === 'join' ? 'Join' : 'Individual' }}
              </span>
            </div>
            <p>
              Sheet:
              <strong>{{ file.sheetName || file.sheets?.[0] || 'Auto-detect' }}</strong>
            </p>
            <p *ngIf="file.extractionMode">
              Extraction: <strong>{{ file.extractionMode }}</strong>
            </p>
            <p *ngIf="file.joinKey">Join key: <strong>{{ file.joinKey }}</strong></p>
            <p *ngIf="file.resolvedPrimaryKey">Resolved key: <strong>{{ file.resolvedPrimaryKey }}</strong></p>
            <p>Columns: <strong>{{ file.columnCount ?? file.columns?.length ?? 0 }}</strong></p>
            <details *ngIf="file.columns?.length">
              <summary>Show detected columns</summary>
              <ul>
                <li *ngFor="let column of file.columns | slice:0:12">
                  <code>{{ column.fieldName || column.header || column.columnLetter }}</code>
                  <span *ngIf="column.dataType"> - {{ column.dataType }}</span>
                </li>
              </ul>
            </details>
          </article>
        </div>
      </div>
    </div> -->
  </section>

  <section class="spriced-workspace" *ngIf="analysis() as data">
    <section class="workbench-main">
      <section id="formulaMappingPanel" class="builder-card formula-mapping-card" *ngIf="selectedFormula() as formula">
        <div class="card-heading formula-mapping-heading">
          <div>
            <span class="eyebrow">Formula Mapping</span>
            <h3>{{ formula.outputField }}</h3>
            <p>{{ activeSheetName() }} / {{ formula.cell }}</p>
          </div>
          <div class="formula-meta-pills">
            <span>{{ formula.ruleId }}</span>
            <span>{{ formula.cell }}</span>
          </div>
        </div>
        <div class="formula-grid">
          <div>
            <span>Original Excel formula</span>
            <code>{{ formula.formula }}</code>
          </div>
          <div>
            <span>Generated expression</span>
            <code>{{ formula.expression }}</code>
          </div>
        </div>
      </section>

      <!-- COMMENTED OUT: Rule Builder section (generate rule from formula)
      <section class="builder-card">
        <div class="card-heading">
          <div>
            <span class="eyebrow">Rule Builder</span>
            <h3>Generate a rule from a formula</h3>
            <p>Translate any Excel formula into a platform rule using the active sheet mapping.</p>
          </div>
          <div class="action-row">
            <button type="button" class="secondary-action" (click)="useSelectedFormulaInBuilder()" [disabled]="!selectedFormula()">
              Use Selected Formula
            </button>
            <button type="button" class="primary-action" (click)="generateRuleFromFormula()" [disabled]="translatingFormula()">
              {{ translatingFormula() ? 'Generating...' : 'Generate Rule' }}
            </button>
          </div>
        </div>

        <div class="message error-message" *ngIf="formulaError()">{{ formulaError() }}</div>

        <div class="formula-builder-grid">
          <label>
            Excel formula
            <textarea
              class="code-input large-code-input"
              [ngModel]="formulaInput()"
              (ngModelChange)="formulaInput.set($event)"
              spellcheck="false"
            ></textarea>
          </label>
          <label>
            Output field
            <input type="text" [ngModel]="formulaOutputField()" (ngModelChange)="formulaOutputField.set($event)" />
          </label>
          <label class="wide-field">
            Cell mapping JSON
            <textarea
              class="code-input large-code-input"
              [ngModel]="formulaCellMappingJson()"
              (ngModelChange)="formulaCellMappingJson.set($event)"
              spellcheck="false"
            ></textarea>
          </label>
        </div>

        <div class="generated-rule-preview" *ngIf="generatedRule() as generatedRule">
          <div class="card-heading compact-heading">
            <div>
              <span class="eyebrow">Generated Rule</span>
              <h3>{{ generatedRule.outputField }}</h3>
              <p>{{ generatedRule.ruleId }}</p>
            </div>
          </div>
          <pre>{{ generatedRule | json }}</pre>
        </div>
      </section>
      END COMMENTED OUT: Rule Builder section -->

      <section class="builder-card translation-schema-card" *ngIf="deamAnalysis() as deam">
        <div class="table-wrap schema-table-wrap">
          <table class="config-table">
            <thead>
              <tr>
                <th>Source</th>
                <th>Column</th>
                <th>Type</th>
                <th>Required</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let column of activeDeamSheet()?.columns; let index = index; trackBy: trackByDeamColumn"
                [class.status-row-highlight]="column.role === 'status'"
              >
                <td>
                  <strong>{{ column.sourceColumn }}</strong>
                  <small>{{ column.sourceHeader }}</small>
                </td>
                <td>
                  <input
                    type="text"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="column.deamColumnName"
                    (ngModelChange)="updateDeamColumn(index, 'deamColumnName', $event)"
                  />
                </td>
                <td>
                  <select
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="column.dataType"
                    (ngModelChange)="updateDeamColumn(index, 'dataType', $event)"
                  >
                    <option value="TEXT">TEXT</option>
                    <option value="INTEGER">INTEGER</option>
                    <option value="NUMERIC">NUMERIC</option>
                    <option value="BOOLEAN">BOOLEAN</option>
                    <option value="DATE">DATE</option>
                    <option value="TIMESTAMP">TIMESTAMP</option>
                  </select>
                </td>
                <td>
                  <input
                    type="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="column.mandatory"
                    (ngModelChange)="updateDeamColumn(index, 'mandatory', $event)"
                  />
                </td>
                <td>
                  <button type="button" class="danger-action" (click)="removeDeamColumn(index)">Remove</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <div class="ingestion-progress-panel" *ngIf="persisting() && ingestionJobId()">
        <ng-container *ngIf="ingestionProgress() as progress">
          <div class="ingestion-batch-info" *ngIf="progress['totalBatches']">
            <div class="ingestion-progress-bar">
              <div class="ingestion-progress-fill" [style.width.%]="progress['percentComplete'] || 0"></div>
            </div>
            <span class="ingestion-batch-label">
              Batch {{ progress['completedBatches'] }}/{{ progress['totalBatches'] }} -
              {{ $any(progress['processedRows']) | number }}/{{ $any(progress['totalRows']) | number }} rows
              ({{ progress['percentComplete'] }}%)
            </span>
          </div>
        </ng-container>
      </div>
      <!-- COMMENTED OUT: Business Logic section (validation rules)
      <section class="builder-card" *ngIf="deamAnalysis()">
        <div class="card-heading">
          <div>
            <span class="eyebrow">Business Logic</span>
            <h3>Validation Rules</h3>
            <p>Rules are validations on top of data. Formula calculations stay in formula mappings, not business rules.</p>
          </div>
          <div class="action-row">
            <button type="button" class="secondary-action" (click)="saveDeamDraft('Rule configuration saved as draft.')">Save Rules</button>
            <button type="button" class="primary-action" (click)="addGlobalRulePlaceholder()">Add Rule</button>
          </div>
        </div>

        <div class="rule-stack" *ngIf="activeGlobalRulePlaceholders().length; else noBusinessRules">
          <details class="rule-editor" *ngFor="let rule of activeGlobalRulePlaceholders(); let ruleIndex = index" open>
            <summary>
              <span class="state-pill" [class.disabled]="!rule.enabled">{{ rule.enabled ? 'Enabled' : 'Disabled' }}</span>
              <strong>{{ rule.name || 'Untitled rule' }}</strong>
              <small>{{ rule.ruleId || rule.event }}</small>
            </summary>
            <div class="rule-editor-body">
              <label class="inline-check">
                <input type="checkbox" [ngModel]="rule.enabled" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'enabled', $event)" />
                Enabled
              </label>
              <div class="editor-grid">
                <label>
                  Event
                  <select [ngModel]="rule.event" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'event', $event)">
                    <option value="on_calculation">on_calculation</option>
                    <option value="before_calculation">before_calculation</option>
                    <option value="after_calculation">after_calculation</option>
                    <option value="on_validation">on_validation</option>
                  </select>
                </label>
                <label>
                  From status
                  <input type="text" [ngModel]="rule.fromStatus" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'fromStatus', $event)" placeholder="optional" />
                </label>
                <label>
                  To status
                  <input type="text" [ngModel]="rule.toStatus" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'toStatus', $event)" placeholder="optional" />
                </label>
                <label>
                  Rule name
                  <input type="text" [ngModel]="rule.name" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'name', $event)" />
                </label>
                <label class="wide-field">
                  Description
                  <textarea [ngModel]="rule.description" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'description', $event)"></textarea>
                </label>
                <label class="wide-field">
                  Expression
                  <textarea class="code-input" [ngModel]="rule.expression" (ngModelChange)="updateGlobalRulePlaceholder(ruleIndex, 'expression', $event)"></textarea>
                </label>
              </div>
              <div class="right-actions">
                <button type="button" class="danger-action" (click)="removeGlobalRulePlaceholder(ruleIndex)">Remove Rule</button>
              </div>
            </div>
          </details>
        </div>
        <ng-template #noBusinessRules>
          <p class="empty-note">No validation rules found in this sheet. Use Add Rule to create one manually.</p>
        </ng-template>
      </section>

      <section class="builder-card" *ngIf="deamAnalysis()">
        <div class="card-heading">
          <div>
            <span class="eyebrow">Workflow</span>
            <h3>Status configuration</h3>
            <p>Detected status columns stay mapped to DEAM. Configure allowed values, defaults, transitions, and status rules.</p>
          </div>
          <div class="action-row">
            <button type="button" class="secondary-action" (click)="saveDeamDraft('Status configuration saved as draft.')">Save Status</button>
            <button type="button" class="primary-action" (click)="addManualStatusField()">Add Status</button>
          </div>
        </div>

        <div class="status-stack" *ngIf="activeDeamSheet()?.statusFields?.length; else noStatuses">
          <details class="status-editor" *ngFor="let status of activeDeamSheet()?.statusFields; let index = index" open>
            <summary>
              <div>
                <span class="state-pill">Status</span>
                <strong>{{ status.sourceHeader }}</strong>
                <small>{{ formatStatusLocation(status) }}</small>
              </div>
              <label class="inline-check">
                <input type="checkbox" [ngModel]="status.included" (ngModelChange)="updateStatusField(index, 'included', $event)" />
                Include
              </label>
            </summary>

            <div class="status-editor-body">
              <div class="status-setup">
                <label>
                  Field name
                  <input type="text" [ngModel]="status.fieldName" (ngModelChange)="updateStatusField(index, 'fieldName', $event)" />
                </label>
                <label>
                  Default
                  <input type="text" [ngModel]="status.defaultValue || ''" (ngModelChange)="updateStatusField(index, 'defaultValue', $event)" />
                </label>
                <label>
                  Allowed values
                  <input type="text" [ngModel]="status.allowedValues.join(', ')" (ngModelChange)="updateStatusAllowedValues(index, $event)" />
                </label>
              </div>

              <div class="chip-row">
                <span *ngFor="let value of status.allowedValues">{{ value }}</span>
              </div>

              <details class="reason-panel">
                <summary>Detection reasons / {{ status.confidence | number: '1.0-2' }} confidence</summary>
                <pre>{{ status.detectionReasons.join('\n') }}</pre>
              </details>

              <div class="workflow-section">
                <div class="workflow-title">
                  <div>
                    <h4>Transitions</h4>
                    <p>Define which status values can move to each next state.</p>
                  </div>
                  <button type="button" class="secondary-action" (click)="addStatusTransition(index)">Add Transition</button>
                </div>
                <div class="transition-table">
                  <div class="transition-head">
                    <span>From</span>
                    <span>To statuses</span>
                    <span></span>
                  </div>
                  <div class="transition-row" *ngFor="let transition of status.transitions; let transitionIndex = index">
                    <input type="text" [ngModel]="transition.fromStatus" (ngModelChange)="updateStatusTransitionFrom(index, transitionIndex, $event)" />
                    <input type="text" [ngModel]="transition.toStatuses.join(', ')" (ngModelChange)="updateStatusTransitionTargets(index, transitionIndex, $event)" />
                    <button type="button" class="danger-action" (click)="removeStatusTransition(index, transitionIndex)">Remove</button>
                  </div>
                </div>
              </div>

              <div class="workflow-section">
                <div class="workflow-title">
                  <div>
                    <h4>Status Rules</h4>
                    <p>Optional hooks that run around status changes.</p>
                  </div>
                  <button type="button" class="secondary-action" (click)="addStatusRulePlaceholder(index)">Add Rule</button>
                </div>

                <div class="nested-rule" *ngFor="let placeholder of status.rulePlaceholders || []; let placeholderIndex = index">
                  <div class="nested-rule-heading">
                    <label class="inline-check">
                      <input
                        type="checkbox"
                        [ngModel]="placeholder.enabled"
                        (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'enabled', $event)"
                      />
                      Enabled
                    </label>
                    <strong>{{ placeholder.name || 'Untitled status rule' }}</strong>
                    <button type="button" class="danger-action" (click)="removeStatusRulePlaceholder(index, placeholderIndex)">Remove</button>
                  </div>
                  <div class="editor-grid">
                    <label>
                      Event
                      <select [ngModel]="placeholder.event" (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'event', $event)">
                        <option value="on_status_change">on_status_change</option>
                        <option value="before_status_change">before_status_change</option>
                        <option value="after_status_change">after_status_change</option>
                      </select>
                    </label>
                    <label>
                      From
                      <input type="text" [ngModel]="placeholder.fromStatus" (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'fromStatus', $event)" />
                    </label>
                    <label>
                      To
                      <input type="text" [ngModel]="placeholder.toStatus" (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'toStatus', $event)" />
                    </label>
                    <label>
                      Rule name
                      <input type="text" [ngModel]="placeholder.name" (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'name', $event)" />
                    </label>
                    <label class="wide-field">
                      Description
                      <textarea [ngModel]="placeholder.description" (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'description', $event)"></textarea>
                    </label>
                    <label class="wide-field">
                      Expression
                      <textarea class="code-input" [ngModel]="placeholder.expression" (ngModelChange)="updateStatusRulePlaceholder(index, placeholderIndex, 'expression', $event)"></textarea>
                    </label>
                  </div>
                </div>
                <p class="empty-note" *ngIf="!(status.rulePlaceholders || []).length">No status rules yet.</p>
              </div>
            </div>
          </details>
        </div>
        <ng-template #noStatuses>
          <p class="empty-note">No status detected for this sheet. Add Status if the workflow field is not present in the workbook.</p>
        </ng-template>
      </section>
      END COMMENTED OUT: Business Logic section -->

      <!-- COMMENTED OUT: Workflow section (status configuration)
      <section class="builder-card" *ngIf="deamAnalysis()">
        <div class="card-heading">
          <div>
            <span class="eyebrow">Workflow</span>
            <h3>Status configuration</h3>
      END COMMENTED OUT: Workflow section -->

      <!-- COMMENTED OUT: Execution section (test calculation)
      <section class="builder-card">
        <div class="card-heading">
          <div>
            <span class="eyebrow">Execution</span>
            <h3>Test calculation</h3>
            <p>Collapsed by default. Open only when validating rule output.</p>
          </div>
          <button type="button" class="secondary-action" (click)="showTestCalculation.set(!showTestCalculation())">
            {{ showTestCalculation() ? 'Hide Console' : 'Open Console' }}
          </button>
        </div>
        <div class="console-grid" *ngIf="showTestCalculation()">
          <label>
            Input JSON
            <textarea class="code-input large-code-input" [ngModel]="inputJson()" (ngModelChange)="inputJson.set($event)" spellcheck="false"></textarea>
          </label>
          <label>
            Output
            <pre>{{ outputJson() || 'Run a rule to see output.' }}</pre>
          </label>
        </div>
        <div class="action-row console-actions" *ngIf="showTestCalculation()">
          <button type="button" class="secondary-action" (click)="executeSelectedRule()" [disabled]="!selectedRule() || executing()">
            {{ executing() && runMode() === 'selected' ? 'Running...' : 'Run Selected' }}
          </button>
          <button type="button" class="primary-action" (click)="executeAllRules()" [disabled]="!activeSheet()?.rules?.length || executing()">
            {{ executing() && runMode() === 'all' ? 'Running...' : 'Run All' }}
          </button>
        </div>
      </section>
      END COMMENTED OUT: Execution section -->

      <!-- <section class="builder-card" *ngIf="deamAnalysis() || workflowPreviewDeamEntries().length || finalDeamSchemaJson()">
        <div class="card-heading">
          <div>
            <span class="eyebrow">Review</span>
            <h3>Final Data Schema</h3>
           
          </div>
          <div class="action-row">
            <button
              type="button"
              class="secondary-action"
              (click)="persistDeamSchema()"
              [disabled]="persisting()"
            >
              {{ persisting() ? 'Saving...' : 'Save' }}
            </button>
            <button type="button" class="primary-action" (click)="downloadDeamSchema()">Download Schema</button>
          </div>

         
          <div class="ingestion-progress-panel" *ngIf="persisting() && ingestionJobId()">
            <ng-container *ngIf="ingestionProgress() as progress">
              <div class="ingestion-batch-info" *ngIf="progress['totalBatches']">
                <div class="ingestion-progress-bar">
                  <div class="ingestion-progress-fill" [style.width.%]="progress['percentComplete'] || 0"></div>
                </div>
                <span class="ingestion-batch-label">
                  Batch {{ progress['completedBatches'] }}/{{ progress['totalBatches'] }} &mdash;
                  {{ $any(progress['processedRows']) | number }}/{{ $any(progress['totalRows']) | number }} rows
                  ({{ progress['percentComplete'] }}%)
                </span>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="validation-panel" *ngIf="schemaValidation() as validation">
          <div class="message error-message" *ngIf="validation.errors.length">
            <strong>Schema errors</strong>
            <ul>
              <li *ngFor="let issue of validation.errors">{{ issue }}</li>
            </ul>
          </div>
          <div class="message warning-message" *ngIf="validation.warnings.length">
            <strong>Schema warnings</strong>
            <ul>
              <li *ngFor="let issue of validation.warnings">{{ issue }}</li>
            </ul>
          </div>
          <p class="message success-message" *ngIf="!validation.errors.length && !validation.warnings.length">Schema preview is valid.</p>
        </div>

        <pre class="schema-preview final-deam-preview" *ngIf="finalDeamSchemaJson()">{{ finalDeamSchemaJson() }}</pre>
      </section> -->
    </section>
  </section>
</section>

